import { Box, Grid, Stack, SvgIcon, Typography } from '@mui/material';
import { ReactComponent as Clock } from 'assets/images/ic_clock.svg';
import { ReactComponent as Growth } from 'assets/images/ic_growth.svg';
import { ReactComponent as MiniDocument } from 'assets/images/ic_mini-document.svg';

const AIApprovalDataset = (
  props: AIMaturityAssessmentPropss
): React.ReactElement => {
  const { pendingCount, onPublicSelect, approvedCount, publicPendingCount } =
    props;
  return (
    <Box className="approval-dataset-wrapper">
      <Grid container className="approval-array-set">
        <Grid item xs={12} sm={4}>
          <Box className="awaiting-approval-dataset">
            <Stack direction="row" alignItems="center">
              <Typography>AIs awaiting approval</Typography>
              <SvgIcon
                component={Clock}
                inheritViewBox
                className="view-icon"
                fontSize="inherit"
                htmlColor="#D1F27A"
              />
            </Stack>
            <Typography variant="h6">{pendingCount}</Typography>
            {/* <Link to="/">Click to filter table</Link> */}
          </Box>
        </Grid>
        <Grid item xs={12} sm={4}>
          <Box className="average-approval">
            <Stack direction="row" alignItems="center">
              <Typography>AIs Approved</Typography>
              <SvgIcon
                component={Growth}
                inheritViewBox
                className="view-icon"
                fontSize="inherit"
                htmlColor="#D1F27A"
              />
            </Stack>
            <Typography variant="h6">{approvedCount}</Typography>
            {/* <Typography component="span">Last 3 months</Typography> */}
          </Box>
        </Grid>
        <Grid
          item
          xs={12}
          sm={4}
          onClick={() => {
            onPublicSelect(1);
          }}
        >
          <Box className="average-approval">
            <Stack direction="row" alignItems="center">
              <Typography>Public submissions pending</Typography>
              <SvgIcon
                component={MiniDocument}
                inheritViewBox
                className="view-icon"
                fontSize="inherit"
                htmlColor="#D1F27A"
              />
            </Stack>
            <Typography variant="h6">{publicPendingCount}</Typography>
            <Typography>Click to view submissions</Typography>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default AIApprovalDataset;
